const loyaltyStamps = {
  stampsSettings: "إعدادات الأختام",
  stampsRequiredToRedeem: "عدد الأختام المطلوبة للاسترداد",
  allMenu: "كل القائمة",
  stampGifts: "هدايا الأختام",
  specificCategories: "فئات محددة",
  specificItems: "أصناف محددة",
  dragAndDropItems: "اسحب وأفلت الأصناف من القائمة الموجودة على اليسار",
  dropItemsHere: "أفلت الأصناف هنا",
  eligibleItemsCategories: "ما هي الأصناف/الفئات المؤهلة للحصول على ختم؟",
  stampImages: "صور الأختام",
  optional: "اختياري",
  stampImagesDescription: "هذا هو المظهر الافتراضي للأختام النشطة والغير نشطة. يمكنك أيضًا تحميل صورك الخاصة. يجب أن تكون الصور على الأقل 4 كيلوبايت وفي أقصى حد 1 ميغابايت.",
  giftImage: "صورة الهدية",
  giftImageDescription: "هذا هو المظهر الافتراضي لختم الهدية. يمكنك أيضًا تحميل صورتك الخاصة. يجب أن تكون الصورة على الأقل 4 كيلوبايت وفي أقصى حد 1 ميغابايت.",
  resetToDefault: "إعادة التعيين إلى الافتراضي",
  save: "حفظ التغييرات",
  saving: "جارٍ الحفظ...",
  fileTooSmall: "يجب أن تكون الصورة أكبر من 4 كيلوبايت",
  fileTooLarge: "يجب أن تكون الصورة أصغر من 1 ميغابايت",
  imageProcessingError: "فشل تحميل الصورة. يرجى المحاولة مرة أخرى.",
  failedToSaveConfiguration: "فشل حفظ الاعدادات",
  configurationSavedSuccessfully: "تم حفظ الاعدادات بنجاح",
  stamps: "أختام",
  gifts: "هدايا",
  stampsExpireIn: "ستنتهي صلاحية الأختام في",
  giftsExpireIn: "ستنتهي صلاحية الهدايا في",
  days: "أيام",
  hours: "ساعات",
  months: "شهور",
  stampsRequiredError: "يجب أن يكون عدد الأختام المطلوبة للاسترداد بين 1 و 9",
  allowMultipleStampsPerOrder: "السماح بعدة أختام لكل طلب",
  allowMultipleStampsPerOrderTooltip:
    "تمكين العميل من الحصول على عدة أختام لهذه المنتجات ضمن نفس الطلب",
  branchNotificationsSettings: "إعدادات إشعارات الفروع",
  selectBranchToCustomize: "اختر فرعًا لتخصيص الإشعارات",
  branchList: "قائمة الفروع",
  notificationMessageEn: "رسالة الإشعار (إنجليزي)",
  notificationMessageAr: "رسالة الإشعار (عربي)",
  notificationMessageEnPlaceholder: "أدخل رسالة الإشعار بالإنجليزية",
  notificationMessageArPlaceholder: "أدخل رسالة الإشعار بالعربية",
  notificationMessageUpdates: "تحديثات رسائل الإشعارات",
  updatesRemainingToday: "{{count}} تحديثات متبقية اليوم",
  notificationUpdatesDelayNote: "قد يستغرق ظهور التحديثات في التطبيق ما يصل إلى 3 ساعات.",
};

export default loyaltyStamps;
